// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoSection-module_wrapper__DV_rU","content":"InfoSection-module_content___85xn","icon":"InfoSection-module_icon__r_Kpt"};